module.exports = __webpack_public_path__ + "static/media/coin-medium.227532be.png";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/coin-medium.png
// module id = 606
// module chunks = 0